import {fetchingData, fetchingDone, raiseError, unauthorized} from './application.actions';
import {bindActionCreators} from 'redux'
import {getToken, refreshToken} from './token_management'

const opts = (settings = {}) => ({
  ...settings,
  headers: {
    ...settings.headers,
    'Authorization': getToken(),
  }
});

const jsonOpts = (settings = {}) => opts({
  ...settings,
  headers: {
    ...settings.headers,
    'Accept': 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  }
});

/** @namespace process.env.REACT_APP_API_URL */
const url = process.env.REACT_APP_API_URL;

const normalizePath = endpoint =>
  endpoint.startsWith('/') ? endpoint.substr(0, 1) : endpoint;

const makeFqUrl = endpoint => `${url}/${normalizePath(endpoint)}`;

const noact = ({type: 'NO_ACT'});

const handleResponse = async (dispatch, success, response) => {
  const actions = bindActionCreators({unauthorized}, dispatch);

  const handleSuccess = payload => {
    const actions = (success || noact)(payload);
    (Array.isArray(actions) ? actions : [actions]).forEach(dispatch);
  };

  const handleError = payload => {
    if (response.status === 401) {
      dispatch(actions.unauthorized());
    } else {
      dispatch(raiseError(payload.errors || ['unknown']))
    }
  };

  let result = undefined;

  try {
    const json = await response.json();
    response.ok ? handleSuccess(json) : handleError(json);
    result = json;
  } catch (e) {
    handleError({errors: [e.message]});
    result =  {errors: [e.message]}
  } finally {
    dispatch(fetchingDone);
  }
  return result;
};

export default dispatch => ({
    get: async (endpoint, fn) => {
      await refreshToken(dispatch);
      dispatch(fetchingData);
      const response = await fetch(makeFqUrl(endpoint), jsonOpts({
        headers: {
          'Pragma': 'no-cache',
          'Cache-Control': 'no-cache'
        }
      }));
      return handleResponse(dispatch, fn, response);
    },
    upload: async (endpoint, data, fn, onProgress) => {
      await refreshToken(dispatch);
      dispatch(fetchingData);

      const options = {
        method: 'post',
        headers: opts().headers
      };

      await new Promise( (res, rej)=>{
        const xhr = new XMLHttpRequest();
        xhr.open(options.method || 'post', makeFqUrl(endpoint));
        for (let header in options.headers||{}) {
          // noinspection JSUnfilteredForInLoop
          xhr.setRequestHeader(header, options.headers[header]);
        }
        xhr.onload = e => {
          const json = JSON.parse(e.target.responseText);
          if (xhr.status >= 200 && xhr.status < 300) {
            const actions = fn(json);
            (Array.isArray(actions) ? actions : [actions]).forEach(dispatch);
          } else if (xhr.status === 401) {
            dispatch(unauthorized());
          } else {
            dispatch(raiseError(json.errors || ['unknown']));
          }
          res();
        };
        xhr.onerror = rej;
        if (xhr.upload && onProgress)
          xhr.upload.onprogress = ({lengthComputable, loaded, total, timeStamp}) => {
            if (lengthComputable) {
              const progress = Math.round((loaded / total) * 100);
              onProgress({progress: `${progress}%`, timeStamp})
            }
          }; // event.loaded / event.total * 100 ; //event.lengthComputable
        xhr.send(data);
      });

      dispatch(fetchingDone);
      // const response = await fetch(makeFqUrl(endpoint), opts({method: 'POST', body: data}));
      // return handleResponse(dispatch, fn, response);
    },
    download: async (endpoint, contentType) => {
      await refreshToken(dispatch);
      dispatch(fetchingData);
      let response = await fetch(makeFqUrl(endpoint), opts({
        headers: {
          Accept: contentType,
          'Pragma': 'no-cache',
          'Cache-Control': 'no-cache'
        }}));
      dispatch(fetchingDone);
      return response.blob();
    },
    post: async (endpoint, body, fn) => {
      await refreshToken(dispatch);
      dispatch(fetchingData);
      const response = await fetch(makeFqUrl(endpoint), jsonOpts({body: JSON.stringify(body), method: 'POST'}));
      return handleResponse(dispatch, fn || body, response);
    },
    postEmptyResponse: async (endpoint, body) => {
      await refreshToken(dispatch);
      dispatch(fetchingData);
      await fetch(makeFqUrl(endpoint), jsonOpts({body: JSON.stringify(body), method: 'POST'}));
    },
    put: async (endpoint, body, fn) => {
      await refreshToken(dispatch);
      dispatch(fetchingData);
      const response = await fetch(makeFqUrl(endpoint), jsonOpts({body: JSON.stringify(body), method: 'PUT'}));
      return handleResponse(dispatch, fn || body, response);
    },
    delete: async (endpoint, body, fn) => {
      await refreshToken(dispatch);
      dispatch(fetchingData);
      const response = await fetch(makeFqUrl(endpoint), jsonOpts({body: JSON.stringify(body), method: 'DELETE'}));
      return handleResponse(dispatch, fn || body, response);

    }
  }
);


// WEBPACK FOOTER //
// ./src/api.js